import type THREE from "./THREE";

/**
 * Eine Ebene an ihren AKTUELLEN Elternteil haengen, falls sie den gewechselt hat.
 *
 * Hintergrund (Jans Fund 04.08.2026: "Bei Gruppen kann ich diese manchmal nicht
 * animieren oder auch per Handler bewegen"): Der Szenenbaum wird inkrementell
 * gepflegt. Die Pivot-Gruppe einer Ebene wird nur bei ihrer ERSTEN Darstellung
 * in den Elternteil gehaengt. Gruppiert man BESTEHENDE Ebenen, existiert deren
 * Pivot laengst — es blieb am alten Elternteil haengen, und die neue Gruppe war
 * leer. Ihre eigene Transform lief korrekt, bewegte aber nichts.
 *
 * Der Aufraeum-Durchlauf in animate() fand das nicht: er vergleicht die
 * vorhandenen THREE-Kinder einer Gruppe gegen usedChildren, entdeckt also nur
 * ZUVIELE Kinder — nie fehlende.
 *
 * `Object3D.add()` loest ein Objekt selbst aus seinem bisherigen Elternteil;
 * ein `remove()` davor ist unnoetig und wuerde nur eine Matrix-Aktualisierung
 * mehr kosten. Weil die Bedingung nach dem Umhaengen falsch ist, kann daraus
 * kein wiederkehrender Baumumbau entstehen.
 */
export function reparentIfMoved(
    child: THREE.Object3D | null | undefined,
    parent: THREE.Object3D | null | undefined,
): boolean {
    if (!child || !parent) return false;
    if (child.parent === parent) return false;
    // Sich selbst (oder einen Vorfahren) unterhaengen wuerde den Baum zerreissen
    // — three.js prueft das nicht.
    for (let p: THREE.Object3D | null = parent; p; p = p.parent) {
        if (p === child) return false;
    }
    parent.add(child);
    return true;
}
